export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: '48d4f9e3-4dd7-4d44-b949-4b78d13fa458',
      authority: 'https://login.microsoftonline.com/6c6faf78-2920-4cab-8820-df3254e685bd',
    },
  },
  apiConfig: {
    scopes: ['api://d68dc168-6be0-473f-b4b5-d18a1dee1b9d/tmaas.mm'],
    uri: 'https://api.tmaas.aae-hub-pre.com',
  },
  webSocketConfig: {
    uri: 'wss://ws.tmaas.aae-hub-pre.com',
  },
};
